<template>
  <div class="bg-background-light-strong">
    <div class="h-container pb-16 md:pb-20">
      <div class="border-b border-border py-12">
        <h3 v-if="props.title">{{ t['w.module.product_description.product_title']({ title: props.title }) }}</h3>
        <div v-if="props.introduction" class="pt-4" v-html="props.introduction" />
      </div>
      <div class="md:h-gap md:grid md:grid-cols-2">
        <ProductDescriptionText v-if="props.texts" :texts="props.texts" :brand="props.brand" @removed-links="handleRemovedLinks" />
        <ProductDescriptionInfo v-if="props.attributes" :attributes="props.attributes" />
      </div>
      <InfoBanner v-if="props.madeToOrder" class="pt-10" :text="t['w.module.product_description.special_order']()" state="light" />
      <ProductDescriptionFile v-if="props.assemblyInstructionsUrl" :assembly-instructions-url="props.assemblyInstructionsUrl" />
      <template v-if="textLinks">
        <div v-for="(link, index) in textLinks" :key="index" class="mt-10 flex items-start">
          <div class="text-subtitle font-medium hover:text-text-strong" v-html="link" />
          <Icon name="arrow-right" class="ml-1 size-6" />
        </div>
      </template>
      <ProductDescriptionHalls v-if="props.recommendedHalls" :recommended-halls="props.recommendedHalls" :product-current-page-path="productCurrentPagePath" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ProductDescriptionInfo from '~/components/product/ProductDescriptionInfo.vue'
import ProductDescriptionText from '~/components/product/ProductDescriptionText.vue'
import ProductDescriptionFile from '~/components/product/ProductDescriptionFile.vue'
import ProductDescriptionHalls from '~/components/product/ProductDescriptionHalls.vue'
import InfoBanner from '~/components/info-banner/InfoBanner.vue'
import Icon from '~/components/icon/Icon.vue'
import type { RecommendedHall } from '~/components/product/recommended-hall-type'
import * as t from '~/messages'

const route = useRoute()

const props = withDefaults(
  defineProps<{
    texts?: string[] | null
    title?: string | null
    introduction?: string | null
    brand?: object | null
    assemblyInstructionsUrl?: string | null
    madeToOrder?: boolean | null
    attributes?: object[] | null
    recommendedHalls?: RecommendedHall[] | null
  }>(),
  {
    texts: null,
    title: null,
    introduction: null,
    brand: null,
    assemblyInstructionsUrl: null,
    madeToOrder: null,
    attributes: null,
    recommendedHalls: null,
  }
)

const textLinks = ref<string[]>([])

const productCurrentPagePath = ref(route.path)
const handleRemovedLinks = (removedLinks: string[]) => {
  textLinks.value = removedLinks
}
</script>
